import { Info } from "lucide-react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import type { AddOnOption } from "@/lib/api/types"
import { AddOnNoteMedia } from "./AddOnNoteMedia"

interface AddonInfoModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  addOn: AddOnOption | null
}

const FALLBACK_DESCRIPTION =
  "An optional add-on to enhance your event experience. Select it during booking and enjoy the extra comfort."

export function AddonInfoModal({
  open,
  onOpenChange,
  addOn,
}: AddonInfoModalProps) {
  if (!addOn) return null

  const description = addOn.note || FALLBACK_DESCRIPTION

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-md rounded-2xl border-border bg-card p-0"
      >
        <div className="p-6 pb-0">
          <DialogHeader>
            <div
              className="mb-3 flex size-11 items-center justify-center rounded-xl"
              style={{ background: "color-mix(in oklch, var(--primary) 12%, transparent)" }}
            >
              <Info className="size-5 text-primary" />
            </div>
            <DialogTitle className="text-lg font-bold tracking-wide text-foreground uppercase">
              {addOn.name}
            </DialogTitle>
            <AddOnNoteMedia
              note={description}
              label={addOn.name}
              className="text-sm text-muted-foreground"
            />
          </DialogHeader>
        </div>

        <div className="p-6 pt-4">
          <div className="rounded-xl border border-border p-3">
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium text-muted-foreground">
                Price per person
              </span>
              <span className="text-sm font-bold text-primary">
                {addOn.priceDeltaPerPerson === 0
                  ? "Free"
                  : `+ €${addOn.priceDeltaPerPerson}`}
              </span>
            </div>
            <div className="mt-1.5 flex items-center justify-between">
              <span className="text-xs font-medium text-muted-foreground">
                Type
              </span>
              <span className="text-xs font-medium text-foreground">
                {(addOn.type ?? "").replaceAll("_", " ")}
              </span>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
